import { render, staticRenderFns } from "./task.vue.html?vue&type=template&id=586a8cf7&scoped=true"
import script from "./task.controller.ts?vue&type=script&lang=js&external"
export * from "./task.controller.ts?vue&type=script&lang=js&external"
import style0 from "./task.vue.html?vue&type=style&index=0&id=586a8cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a8cf7",
  null
  
)

export default component.exports